/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableCell, TableRow } from "@material-ui/core"
import { ModalDeleteConfirm, TableAction } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  defaultToastError,
  formatNumber,
  isNull,
  defaultToastSuccess,
  convertToValidPrice,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useContext, useEffect, useState } from "react"
import { DaftarRikjang, getTotal, getTotalFilterID, Perhitungan } from ".."
import { FormContext } from "../../context/FormContext"
import {
  ModalDaftarRikjang,
  RESET_STATE_DAFTAR_RIKJANG,
  deleteRikjangById,
  getRikjangByPenjualanID,
} from "./DaftarRikjang/helpers"

function TabRikjang({
  perhitunganPenjualan,
  setPerhitunganPenjualan,

  rowsRikjangByKelas,
  setNewDataRikjangByKelas,
  loading,

  handleClickReset,

  totalDataRikjangByKelas,

  formFilterRikjangByKelas,
  setFormFilterRikjangByKelas,
}) {
  const [rows, setRows] = useState([])

  const [formRikjang, setFormRikjang] = useState(RESET_STATE_DAFTAR_RIKJANG)
  const { formData, setFormData } = useContext(FormContext)

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalRikjang, setShowModalRikjang] = useState(false)

  const getRikjangDijual = () => {
    if (isNull(formData.penjualan_id)) {
      const rikjang = formData.rikjang.filter(
        (e) =>
          e.kelas_id === formData.kelas_id &&
          e.asuransi_id === formData.asuransi_id,
      )
      setRows(rikjang)
    }
  }

  const deleteRikjangDijual = async () => {
    const filterRikjang = rows.filter((e) => e.id !== formRikjang.id)

    if (!isNull(formData.penjualan_id)) {
      const totalRikjang = await getTotalFilterID(
        rows,
        formRikjang.id,
        "rikjang",
      )

      const totalBarang = getTotal(formData.barang, "barang")
      const totalPaket = getTotal(formData.paket, "paket")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")

      const jumlah =
        totalBarang + totalRikjang + totalPaket + totalJasa + totalFasilitas

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const form = {
        id: formRikjang.id,
        penjualanId: formData.penjualan_id,
        harga_total_rikjang: convertToValidPrice(totalRikjang),
        total_penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await deleteRikjangById(form)
      if (res.state) {
        setShowModalDeleteConfirm(false)
        await setNewRikjangDijual(filterRikjang, false)
        defaultToastSuccess(res.message)
      } else {
        setShowModalDeleteConfirm(false)

        defaultToastError(res.message)
      }
    } else {
      setShowModalDeleteConfirm(false)
      await setNewRikjangDijual(filterRikjang, false)
      defaultToastSuccess("List Rikjang berhasil dihapus")
    }
  }

  function clickUpdate(row) {
    setShowModalRikjang(!showModalRikjang)
    if (isNull(formData.penjualan_id)) {
      setFormRikjang({
        id: row.id,
        mh_rikjang_id: row?.mhrikjangId,
        rikjang_id: row?.rikjang_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: row.hargaCustom2,
        kelas_id: row.kelas_id,
        asuransi_id: row.asuransi_id,
        namaRikjang: row.namaRikjang,
        doctor_id: isNull(row.doctor_id) ? null : parseInt(row.doctor_id),
        doctor_name: isNull(row.doctor_name) ? "Pilih Dokter" : row.doctor_name,
        diskon: row.diskon,
      })
    } else {
      setFormRikjang({
        id: row.id,
        mh_rikjang_id: row?.mhRikjangId,
        rikjang_id: row?.rikjang_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: formatNumber(row.hargaCustom),
        namaRikjang: row.namaRikjang,
        total: row.hargaCustom * parseInt(row.qty),
        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        doctor_id: isNull(row.doctor_id) ? null : parseInt(row.doctor_id),
        doctor_name: isNull(row.doctor_name) ? "Pilih Dokter" : row.doctor_name,
        diskon: row.diskon,
      })
    }
    setShowModalRikjang(!showModalRikjang)
  }

  function clickDelete(row) {
    setFormRikjang({
      ...formRikjang,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  useEffect(() => {
    ;(async () => {
      await setNewDataRikjangByKelas()
      if (isNull(formData.penjualan_id)) {
        getRikjangDijual()
      }
    })()
  }, [formData.kelas_id, formData.asuransi_id, formData.reload]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickSelect = (row) => {
    if (!isNull(formData.kelas_id)) {
      setFormRikjang({
        id: "",
        rikjang_id: row.id_rikjang,
        mh_rikjang_id: row.id,
        qty: 1,
        keterangan: "-",
        harga: row.harga_custom,
        hargaCustom: row.harga_custom,
        hargaCustom2: formatNumber(row.harga_custom),
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        namaRikjang: row.namaMsRikjang,
        doctor_id: formData.dokter_id,
        doctor_name: formData.dokter_name,
        diskon: formData.diskon?.diskon_rikjang ?? 0,
      })
      setShowModalRikjang(!showModalRikjang)
    } else {
      defaultToastError("Kelas tidak boleh kosong!")
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: isNull(rows) ? [] : rows,
    orderByDefault: "namaRikjang",
    orderByRow: ["namaRikjang"],
  })

  const setNewRikjangDijual = async (
    rikjang = formData.rikjang,
    is_jurnal = formData.is_jurnal,
  ) => {
    const reload = formData.reload_perhitungan || false
    if (isNull(formData.penjualan_id)) {
      setRows(rikjang)

      setFormData({
        ...formData,
        rikjang,
        is_jurnal,
        reload_perhitungan: !reload,
      })
    } else {
      const res = await getRikjangByPenjualanID(formData.penjualan_id)
      if (res.state) {
        setRows(res.data)
        setFormData({
          ...formData,
          rikjang: res.data,
          is_jurnal,
          reload_perhitungan: !reload,
        })
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(formData.penjualan_id)) {
        await setNewRikjangDijual()
      }
    })()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.reload,
    formData.penjualan_id,
  ]) // eslint-disable-line react-hooks/exhaustive-deps
  let total = 0

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteRikjangDijual()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalRikjang && (
        <ModalDaftarRikjang
          setShowModal={() => setShowModalRikjang(false)}
          formRikjang={formRikjang}
          setFormRikjang={setFormRikjang}
          setNewRikjangDijual={setNewRikjangDijual}
          totalPenjualan={perhitunganPenjualan.jumlah}
          sisaPenjualan={perhitunganPenjualan.total}
          handleClickSelect={handleClickSelect}
          setNewDataRikjangByKelas={setNewDataRikjangByKelas}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6}>
          <DaftarRikjang
            formRikjang={formRikjang}
            setFormRikjang={setFormRikjang}
            rows={rowsRikjangByKelas}
            handleClickSelect={handleClickSelect}
            setNewDataRikjangByKelas={setNewDataRikjangByKelas}
            setNewRikjangDijual={setNewRikjangDijual}
            totalData={totalDataRikjangByKelas}
            formFilterRikjangByKelas={formFilterRikjangByKelas}
            setFormFilterRikjangByKelas={setFormFilterRikjangByKelas}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </Grid>
      </Grid>

      <div className="mt-1">
        <FreezeTableClient
          title="DAFTAR RIKJANG YANG DIJUAL"
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              const jumlahRaw = (row.hargaCustom - row.nilai_diskon) * row.qty
              const jumlah = jumlahRaw
              total += jumlah
              return (
                <TableRow hover key={index}>
                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {!formData.is_lock && !formData.is_close && (
                      <TableAction
                        clickDelete={() => clickDelete(row)}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left">{row?.namaRikjang}</TableCell>
                  <TableCell align="left">{row?.doctor_name}</TableCell>

                  <TableCell align="left" width={"5%"}>
                    {row?.qty}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.hargaCustom)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.total_hpp)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.diskon)}%
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.nilai_diskon)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(jumlah)}
                  </TableCell>
                </TableRow>
              )
            })}

          {rows.length > 0 && (
            <TableRow>
              <TableCell colSpan={headCells.length - 1} align="right">
                TOTAL
              </TableCell>
              <TableCell align="right">{formatNumber(total)}</TableCell>
            </TableRow>
          )}
        </FreezeTableClient>
      </div>
    </>
  )
}

const MemoizeTabRikjang = React.memo(TabRikjang)
export default MemoizeTabRikjang

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "doctor_name",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "BANYAK",
    align: "left",
  },
  {
    id: "hargaCustom2",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "hpp",
    disablePadding: false,
    label: "HPP",
    align: "left",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
  },
  {
    id: "nilai_diskon",
    disablePadding: false,
    label: "NILAI DISKON",
    align: "left",
  },
  {
    id: "total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
]
